import React, { FC, useEffect } from 'react';
import { SelectInput, useTranslate } from 'react-admin';
import { useForm } from 'react-final-form';

import { useMasterCurrency } from '~/hooks/currencies';
import { usePnlAccounts } from '~/hooks/pnlAccounts';
import { GlTypeLabel } from '~/components';
import { Account } from '~/types';
import { l } from '../CurrenciesList';

const accountOptionText = (choice?: Account) =>
  choice ? <GlTypeLabel glType={choice.glType} text={choice.alias} /> : '';

const ConversionProfitAccountSelect: FC<any> = () => {
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  const masterCurrencyQuery = useMasterCurrency();
  const pnlAccountsQuery = usePnlAccounts({ regulatoryType: 'EQUITY' });

  const masterCurrency = masterCurrencyQuery.data?.code;
  const masterPnlAccounts =
    masterCurrency &&
    pnlAccountsQuery.data?.filter(
      (item) => item.currency === masterCurrency && item.type !== 'SETTLEMENT'
    );

  const form = useForm();
  useEffect(() => {
    return () => {
      form.change('profitAccountId', undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SelectInput
      source='profitAccountId'
      choices={masterPnlAccounts}
      optionText={accountOptionText}
      label={t('profitAccountId')}
      disabled={pnlAccountsQuery.isLoading}
      allowEmpty
    />
  );
};

export default ConversionProfitAccountSelect;
